// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Link } from 'react-router'
import secnavitems from '../data/secnavitems.json'

export class SecSidebar extends Component {

    constructor(props) {
        super(props)

        this.populateTopPanelItems = this.populateTopPanelItems.bind(this)
        this.loadPanelItems = this.loadPanelItems.bind(this)

    }

    loadPanelItems() {
        let tempTopPanelItems = []

        if (this.props.menuItemsKey === "dynamic") {
            tempTopPanelItems = this.props.menuItems
        }
        else {
            tempTopPanelItems = secnavitems[this.props.menuItemsKey]
        }

        return tempTopPanelItems
    }

    populateTopPanelItems() {
        let topPanelItems = this.loadPanelItems()

        return topPanelItems.map((item, index) => {
            let styleClasses = "panel-item"

            if (this.props.profile === index) {
                styleClasses += " active"
            }

            return (

                <Link key={index} className={styleClasses} to={item.link}>
                    <div className="icon-container">
                        <img src={item.icon} alt="icon" />
                    </div>
                    <span>
                        {item.title}
                    </span>
                </Link>
            )
        })
    }

    render() {
        return (
            <div className="sec-side-bar-container">
                <section className="sec-side-panel">
                    <section className="top">
                        {this.populateTopPanelItems()}
                    </section>

                </section>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/secsidebar.js